import { connect } from 'react-redux';
import {
  selectors as siteGroupsSelectors,
  actions as siteGroupsActions,
} from 'src/redux/data/siteGroups';
import { selectors as operatorsDataSelectors } from 'src/redux/data/operators';
import { selectors as customersDataSelectors } from 'src/redux/data/customers';
import { API_STATUS } from 'src/utils/api-constants';

const mapStateToProps = state => ({
  siteGroups: siteGroupsSelectors.getSiteGroups(state)?.data,
  isDataLoading:
    siteGroupsSelectors.getStatus(state) === API_STATUS.LOADING ||
    operatorsDataSelectors.isLoadingOperators(state) ||
    customersDataSelectors.isLoadingCustomers(state),
});

const mapActionCreators = {
  getSiteGroups: siteGroupsActions.getSiteGroups,
};

const Connector = connect(mapStateToProps, mapActionCreators);
export default Connector;
